import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../scss/IA.scss";
import picture from "../images/Group 10753.svg";
function IASaveModal({ isOpen, toggle, message }) {
  return (
    <Modal isOpen={isOpen}>
      <div className="saveIA--modal">
        {message === 1 ? (
          <p>
            Se ha adjuntado <br /> El análisis en el contrato
          </p>
        ) : (
          <p>Informacion Guardada</p>
        )}

        <img src={picture} width={128} height={103} />
        <button onClick={toggle}>Continuar</button>
      </div>
    </Modal>
  );
}

export default IASaveModal;
